<template>
	<div
    class="notification-prompt u-trans pa-3"
    :class="{
      'active': isHtmlPromptShowed
    }"
  >
    <p class="font-weight-bold mb-2">{{ t('common.turnOnTheNotifications') }}</p>
    <p class="mb-2">{{ t('common.weWillKeppyouInformedAboutHelloYTa') }}</p>
    <div class="text-right">
      <button
        class="promt-cancel u-trans mr-3"
        @click="isHtmlPromptShowed = false"
      >
        {{ t('common.noThanks') }}
      </button>
      <v-btn color="primary" @click="closeHtmlPrompt">
        <span class="text-white text-normal">{{ t('common.allow') }}</span>
      </v-btn>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {}
});

const emit = defineEmits([
  'update:modelValue',
  'onAccept'
]);

const isHtmlPromptShowed = computed({
  get: () => {
    return !!props.modelValue;
  },
  set: (val) => {
    emit('update:modelValue', val);
  }
});

const closeHtmlPrompt = () => {
	isHtmlPromptShowed.value = false;
  emit('onAccept');
}
</script>
<style lang="scss" scoped>
.promt-cancel {
	&:hover { color: var(--red); }
}
.notification-prompt {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	margin-inline: auto;
	width: 300px;
	height: 140px;
	font-size: 14px;
	background-color: white;
	box-shadow: 0 0 16px rgba(0, 0, 0, 0.2);
	transform: translateY(-110%);
	z-index: 900;
	&.active {
		top: 10px;
		transform: translateY(0);
	}
}
</style>
